module.exports = __webpack_public_path__ + "media/images/cervantes_caes_logo-0ba2414c1b94497a8544653124bd4fd4.gif";